export const POST_CLICK_ADD_TO_CART = 1
